import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-edit-payments',
  templateUrl: './edit-payments.component.html',
  styleUrls: ['./edit-payments.component.scss']
})
export class EditPaymentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
